import Vue from 'vue';
import VueSession from 'vue-session';

import App from './App.vue';
import router from './routes';
import store from './store';

import toast from 'vue-toast-notification';

import ElementUI from 'element-ui';
import { ElementTiptapPlugin } from 'element-tiptap';
// import ElementUI's styles
import 'element-ui/lib/theme-chalk/index.css';
// import this package's styles
import 'element-tiptap/lib/index.css';
// Import one of available themes
//import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-sugar.css';

//import vuetify from './plugins/vuetify';
//import VuetifyDialog from 'vuetify-dialog';
import * as VueGoogleMaps from 'vue2-google-maps';

Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyBsH7a7KH9cuIdjaoGWz0lfUsvl7Nm9dfQ',
		libraries: 'places,marker',
		mapIds: ['46fb6c3e4b269cb25ccb5212'],
		loading: 'async',
		channel: 'herp-v1',
	},
});

import VueImg from 'v-img';
Vue.use(VueImg);

Vue.use(ElementUI);
Vue.use(ElementTiptapPlugin);
import VueCurrencyInput from 'vue-currency-input';

const pluginOptions = {
	/* see config reference */
	globalOptions: { currency: null, locale: 'en', 'distraction-free': false },
};
Vue.use(VueCurrencyInput, pluginOptions);

// import VueHotkey from 'v-hotkey';
// Vue.use(VueHotkey);

import vueMoment from 'vue-moment';
import moment from 'moment-timezone';

// moment.tz.setDefault('UTC');
Vue.prototype.$moment = moment;

Vue.use(vueMoment, { moment });
// Vue.use(VuetifyDialog, {
// 	context: {
// 		vuetify,
// 	},
// });

var sessionOptions = {
	persist: true,
};
Vue.use(VueSession, sessionOptions);

Vue.use(toast, {
	position: 'bottom',
});

import VueLodash from 'vue-lodash';
import lodash from 'lodash';
Vue.use(VueLodash, { lodash: lodash });

// import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
// import 'bootstrap/scss/bootstrap.scss';
// Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead);

import Autocomplete from 'vuejs-auto-complete';
Vue.component('autocomplete', Autocomplete);

import VueColumnsResizable from 'vue-columns-resizable';
Vue.use(VueColumnsResizable);
// import VueMask from 'v-mask';
// Vue.use(VueMask);

// 나중에 v-money 삭제할 것
// import money from 'v-money';
// Vue.use(money, { precision: 0 });

Vue.config.productionTip = false;

import VueAlertify from 'vue-alertify';
Vue.use(VueAlertify, {
	transition: 'pulse',
	glossary: {
		title: 'Confirm',
		ok: 'OK',
		cancel: 'Cancel',
	},
});

// Vue.filter('df', function(date, format) {
// 	return moment(date)
// 		.utc()
// 		.format(format);
// });

// Vue.filter('sdf', function(date) {
// 	//Standard format
// 	return moment(date)
// 		.utc()
// 		.format('MM-DD-YYYY');
// });

// Vue.filter('ldf', function(date, format) {
// 	//local format
// 	return moment(date).format(format);
// });

Vue.prototype.$timeZones = ['America/New_York', 'America/Los_Angeles', 'America/Chicago', 'Asia/Seoul'];

Vue.prototype.$userTypes = [
	{ value: 'staff', text: 'Office' },
	{ value: 'salesman', text: 'Salesman' },
	{ value: 'driver', text: 'Driver' },
	{ value: 'whstaff', text: 'Warehouse Staff' },
];

Vue.prototype.$activeTags = [
	{ value: 'A', text: 'All Status' },
	{ value: 'Y', text: 'Active' },
	{ value: 'N', text: 'In-Active' },
];

Vue.prototype.$closedTags = [
	{ value: 'A', text: 'All' },
	{ value: 'Y', text: 'Closed' },
	{ value: 'N', text: 'Not-Closed' },
];

Vue.prototype.$receivedTags = [
	{ value: 'A', text: 'All' },
	{ value: 'Y', text: 'Received' },
	{ value: 'N', text: 'Not-Received' },
];

Vue.prototype.$paymentStatusTags = [
	{ value: 'A', text: 'All Payment' },
	{ value: 'PAID', text: '지급 완료' },
	{ value: 'UNPAID', text: '미지급' },
	{ value: 'OTHERS', text: 'Others' },
];

Vue.prototype.$cbpStatusTags = [
	{ value: 'A', text: 'All CBP' },
	{ value: 'COMPLETED', text: '완료' },
	{ value: 'OTHERS', text: 'Others' },
];

Vue.prototype.$shippingStatusTags = [
	{ value: 'A', text: 'All Shipping' },
	{ value: 'COMPLETED', text: '완료' },
	{ value: 'UNPAID', text: '미지급' },
	{ value: 'OTHERS', text: 'Others' },
];

Vue.prototype.$saleStatusCodes = [
	{ code: 'O', name: 'Open' },
	{ code: 'A', name: 'Approved' },
	{ code: 'P', name: 'Packing' },
	{ code: 'W', name: 'Packed Shipment' },
	{ code: 'I', name: 'Invoice' },
	{ code: 'C', name: 'Confirmed' },
	{ code: 'H', name: 'Hold' },
	{ code: 'PH', name: 'Packed Hold' },
	// { code: 'C', name: 'Black Order' },
	{ code: 'V', name: 'Void Sales Order' },
	// { code: 'D', name: 'Deleted' },
	// { code: 'RH', name: 'Return Hold' },
	// { code: 'RC', name: 'Return Confirm' },
	// { code: 'RV', name: 'Return Void' },
	// { code: 'RD', name: 'Return Deleted' },
	{ code: 'VI', name: 'Void Invoice' },
];

Vue.prototype.$scStatusCodes = [
	{ code: 'R', name: 'Request' },
	{ code: 'C', name: 'Confirmed' },
	{ code: 'U', name: 'Used' },
	{ code: 'W', name: 'Void' },
];

Vue.prototype.$sampleStatusCodes = [
	{ code: 'E', name: 'Entry' },
	{ code: 'R', name: 'Request' },
	{ code: 'A', name: 'Approved' },
	{ code: 'W', name: 'Packed' },
	{ code: 'D', name: 'Ready for Sample' },
	{ code: 'P', name: 'Pick Up' },
	{ code: 'V', name: 'Void' },
	// { code: 'T', name: 'Return' },
];

Vue.prototype.$packagingTypes = [
	{ code: 'PKG', name: 'Package' },
	{ code: 'PLT', name: 'Pallet' },
];

Vue.prototype.$handlingUnitTypes = [
	{ code: 'PKG', name: 'Package(s)' },
	{ code: 'PLT', name: 'Pallet(s)' },
];

Vue.prototype.$partnerBlockReasons = ['BOUNCE', 'STOP PAYMENT', 'BANK ACCOUNT CLOSED', 'R/T CREDIT', 'R/T SHIPPING CHARGE', 'ADD FREIGHT FEE', 'AR OVER SOME PERIOD (ex 90, 100)', 'NO SALE IN 1 YEAR', 'NO SALE IN 2 YEARS', 'OTHER'];

// function getStatusCode(code) {
// 	for (var i = 0; i < Vue.prototype.$saleStatusCodes.length; i++) {
// 		if (Vue.prototype.$saleStatusCodes[i].code === code) {
// 			return Vue.prototype.$saleStatusCodes[i];
// 		}
// 	}
// }

// export function getPossibleStatus(status_code) {
// 	if (status_code == 'O') return [getStatusCode('O'), getStatusCode('A'), getStatusCode('H')];
// 	if (status_code == 'H') return [getStatusCode('O'), getStatusCode('A'), getStatusCode('H'), getStatusCode('V')];
// 	if (status_code == 'I') return [getStatusCode('I')];
// 	else return Vue.prototype.$saleStatusCodes;
// }

Vue.prototype.$codeTypes = [
	{ value: 'ACT', text: 'A/R Credit Type' },
	{ value: 'AT', text: 'A/R Type' },
	{ value: 'BK', text: 'Bank' },
	{ value: 'BPT', text: 'Brazillian Pack Type' },
	{ value: 'BT', text: 'Business Type' },
	// { value: 'CDT', text: 'Customer Document Type' },
	{ value: 'CO', text: 'Country' },
	{ value: 'COL', text: 'Color' },
	{ value: 'CS', text: 'Check Status' },
	{ value: 'DOT', text: 'Document Type' },
	{ value: 'DP', text: 'Department' },
	{ value: 'DT', text: 'Delivery Type' },
	{ value: 'ES', text: 'Event Sales' },
	{ value: 'GR', text: 'Grade' },
	{ value: 'ICC', text: 'Item Class Category' },
	{ value: 'ICG', text: 'Item Class Group' },
	{ value: 'ID', text: 'Invoice Discount' },
	{ value: 'IDA', text: 'Item Department A' },
	{ value: 'IDB', text: 'Item Department B' },
	// { value: 'IG', text: 'Item Group' },
	{ value: 'IL', text: 'Import Locations' },
	{ value: 'PDT', text: 'P/O Delivery Type' },
	{ value: 'PHT', text: 'P/O Holding Type' },
	{ value: 'PLT', text: 'Pallet' },
	{ value: 'PT', text: 'Payment Term' },
	{ value: 'PTG', text: 'Payment Term Group' },
	{ value: 'PTE', text: 'Payment Type' },
	{ value: 'RM', text: 'Remarks' },
	{ value: 'RR', text: 'Return Reason' },
	{ value: 'RC', text: 'Race' },
	{ value: 'RPT', text: 'Receipt Type' },
	{ value: 'RT', text: 'Return Type' },
	{ value: 'SC', text: 'Ship Charge' },
	{ value: 'SIZ', text: 'Size' },
	{ value: 'SLT', text: 'Slip Type' },
	{ value: 'ST', text: 'Sales Team' },
	{ value: 'TDT', text: 'To Do Type' },
	{ value: 'TT', text: 'Trade Terms' },
	{ value: 'TTR', text: 'Territory' },
	{ value: 'UM', text: 'Unit' },
	{ value: 'WG', text: 'Wig Group' },
	{ value: 'WL', text: 'W/H Location' },
	{ value: 'ZHC', text: 'Zone Handling Charge' },
];

Vue.prototype.$colorListForChart = ['#4466c7', '#47a5fc', '#169e94', '#8bc743', '#faa306', '#f23551', '#cd2330', '#910d3e', '#0c4266', '#135e71'];
Vue.prototype.$colorsForLineChart = ['#6f8cdc', '#43c7c2', '#d28994'];

Vue.filter('userTypeName', function(userType) {
	for (var i = 0; i < Vue.prototype.$userTypes.length; i++) {
		if (Vue.prototype.$userTypes[i].value === userType) {
			return Vue.prototype.$userTypes[i].text;
		}
	}
});

Vue.filter('saleStatusName', function(saleStatusCode) {
	for (var i = 0; i < Vue.prototype.$saleStatusCodes.length; i++) {
		if (Vue.prototype.$saleStatusCodes[i].code === saleStatusCode) {
			return Vue.prototype.$saleStatusCodes[i].name;
		}
	}
});

Vue.filter('scStatusName', function(scStatusCode) {
	for (var i = 0; i < Vue.prototype.$scStatusCodes.length; i++) {
		if (Vue.prototype.$scStatusCodes[i].code === scStatusCode) {
			return Vue.prototype.$scStatusCodes[i].name;
		}
	}
});

Vue.filter('sampleStatusName', function(sampleStatusCode) {
	for (var i = 0; i < Vue.prototype.$sampleStatusCodes.length; i++) {
		if (Vue.prototype.$sampleStatusCodes[i].code === sampleStatusCode) {
			return Vue.prototype.$sampleStatusCodes[i].name;
		}
	}
});

Vue.filter('sourceClient', function(source) {
	if (!source) return '';
	var s = String(source).toUpperCase();
	if (s === 'MOBILE APP' || s === 'OFFLINE' || s === 'MOBILE') return 'APP';
	if (s === 'PC WEB' || s === 'MOBILE WEB' || s === 'PC') return 'WEB';
	return source;
});

import { toCurrency, commaSeparated } from '@/utils/etc.js';

Vue.filter('toCurrency', toCurrency);

Vue.filter('toCurrency3', function(value) {
	if (typeof value !== 'number') {
		return value;
	}
	let val = (value / 1).toFixed(3);
	return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
});

Vue.filter('toPOCurrency', function(value, decimal_point) {
	if (typeof value !== 'number') {
		return value;
	}

	if (decimal_point == 3) {
		let val = (value / 1).toFixed(3);
		return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	} else return toCurrency(value);
});

Vue.filter('toCurrencyZeroNull', function(value) {
	if (typeof value !== 'number') {
		return value;
	}
	if (value != 0) {
		let val = (value / 1).toFixed(2);
		return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	} else {
		return null;
	}
});

Vue.filter('commaSeparated', commaSeparated);

Vue.filter('commaSeparatedZeroNull', function(value) {
	if (typeof value !== 'number') {
		return value;
	}
	if (value) {
		let val = (value / 1).toFixed(0);
		return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	} else {
		return null;
	}
});

Vue.filter('fillZeroForDisplayNo', function(value, digit) {
	if (typeof value !== 'number') return value;

	let val = value.toString();
	while (val.length < digit) {
		val = '0' + val;
	}

	return val;
});

Vue.filter('toMMddyyyyHHmmss', function(value) {
	if (!value) return value;

	let d = null;
	try {
		d = new Date(value);
	} catch {
		return value;
	}

	return Vue.prototype.$moment(d).format('MM-DD-YYYY HH:mm:ss');
});

Vue.filter('hideYear', function(value, format) {
	let val = '';

	if (value) {
		if (!format) format = 'MM-DD-YYYY';
		format = format.toUpperCase();
		const rep_list = ['Y', 'M', 'D', 'H', 'I', 'S']; // 년, 월, 일, 시, 분, 초

		let pre_end_idx = format.indexOf('Y');
		if (pre_end_idx > 0) {
			for (let i = pre_end_idx - 1; i > -1; i--) {
				if (rep_list.some(rep => rep === format.charAt(i))) {
					pre_end_idx = i + 1;
					break;
				}
			}

			val += value.substring(0, pre_end_idx);
		}

		let suf_start_idx = format.lastIndexOf('Y');
		if (suf_start_idx > 0) {
			for (let i = suf_start_idx + 1; i < format.length; i++) {
				if (rep_list.some(rep => rep === format.charAt(i))) {
					suf_start_idx = i;
					break;
				}
			}

			if (val) val += ' ';
			val += value.substring(suf_start_idx, value.length);
		}
	}

	return val;
});

import { convertYMDToMDY } from '@/utils/date';
Vue.filter('convertYMDToMDY', convertYMDToMDY);

//날짜 필터 포멧

import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format';
// Vue.use(VueFilterDateFormat, {
// 	dayOfWeekNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
// 	dayOfWeekNamesShort: ['Su', 'Mo', 'Tu', 'We', 'Tr', 'Fr', 'Sa'],
// 	monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
// 	monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
// 	// Timezone offset, in minutes (0 - UTC, 180 - Russia, undefined - current)
// 	timezone: 0,
// });
Vue.use(VueFilterDateFormat);

import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
Chart.plugins.register(ChartDataLabels);

new Vue({
	render: h => h(App),
	router,
	//vuetify,
	store,
}).$mount('#app');
